import { Routes, Route } from 'react-router-dom'
import TopBar from './components/TopBar'
import Footer from './components/Footer'
import CallBar from './components/CallBar'
import Home from './pages/Home'
import Reserve from './pages/Reserve'
import NotFound from './pages/NotFound'

export default function App() {
  return (
    <>
      <TopBar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/reserve/:unitId" element={<Reserve />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <CallBar />
    </>
  )
}
